export default __webpack_public_path__ + "static/6-a915bd3ed1fbfef65e03e20fcbc95c88.webp";